import { defineMessages } from '../define';

export default defineMessages({
  // Загрузки
  'components.uploads.stop': { ru: 'Стоп', en: 'Stop' },
  'components.uploads.remove': { ru: 'Убрать', en: 'Remove' },
  'components.uploads.checking': { ru: 'Проверяем файл…', en: 'Checking file…' },
  'components.uploads.progress': { ru: '{percent}% · {done} из {total}', en: '{percent}% · {done} of {total}' },
  'components.uploads.resumed': { ru: ' · продолжаем с места обрыва', en: ' · resuming where it stopped' },
  'components.uploads.done': { ru: '100% · Загружено ✓', en: '100% · Uploaded ✓' },
  'components.uploads.stopped': { ru: 'Загрузка остановлена', en: 'Upload stopped' },
  'components.uploads.resume': { ru: 'Продолжить', en: 'Resume' },
  'components.uploads.retry': { ru: 'Повторить', en: 'Retry' },
  'components.uploads.unnamed': { ru: 'Файл без имени', en: 'Unnamed file' },
  'components.uploads.earlier': { ru: 'загружен ранее', en: 'uploaded earlier' },
  'components.uploads.incomplete': {
    ru: 'Загрузка не завершена. Выберите этот файл снова для докачки',
    en: 'Upload not finished. Pick this file again to resume',
  },
  'components.uploads.uploaded': { ru: 'Загружено', en: 'Uploaded' },

  // Материалы
  'components.materials.illustrations': {
    ru: { one: '{n} иллюстрация', few: '{n} иллюстрации', many: '{n} иллюстраций', other: '{n} иллюстрации' },
    en: { one: '{n} illustration', other: '{n} illustrations' },
  },
  'components.materials.videos': {
    ru: { one: '{n} видео', few: '{n} видео', many: '{n} видео', other: '{n} видео' },
    en: { one: '{n} video', other: '{n} videos' },
  },
  'components.materials.uploadingVideos': { ru: 'Загружаем {videos} · {percent}%', en: 'Uploading {videos} · {percent}%' },
  'components.materials.uploadingIllustrations': { ru: 'Загружаем {items} · {percent}%', en: 'Uploading {items} · {percent}%' },
  'components.materials.checkUpload': { ru: '· проверьте загрузку', en: '· check the upload' },
  'components.materials.aria': { ru: 'Материалы', en: 'Materials' },
  'components.materials.title': { ru: 'Загрузить материалы', en: 'Upload materials' },
  'components.materials.yourVideos': { ru: 'Ваши видео', en: 'Your videos' },
  'components.materials.videosTitle': { ru: 'Видео', en: 'Video' },
  'components.materials.videosHint': {
    ru: 'Одна или несколько частей рассказа, смонтируем их в одно видео',
    en: 'One or more parts of your story. We will edit them into a single video',
  },
  'components.materials.addVideo': { ru: 'Добавить видео', en: 'Add video' },
  'components.materials.thumbsAria': { ru: 'Превью загруженных видео', en: 'Previews of uploaded videos' },
  'components.materials.uploadedSummary': {
    ru: 'Загружено {videos} · {duration} · {size}',
    en: 'Uploaded {videos} · {duration} · {size}',
  },
  'components.materials.uploadingSummary': { ru: '{videos} · {percent}%', en: '{videos} · {percent}%' },
  'components.materials.checkSummary': { ru: '{videos} · проверьте загрузку', en: '{videos} · check the upload' },
  'components.materials.notice': {
    ru: 'Не сворачивайте приложение. Дождитесь загрузки файлов. Настройки ниже можно менять, пока идёт загрузка.',
    en: 'Keep the app open and wait for the files to upload. You can change the settings below while uploading.',
  },
  'components.materials.filesOrder': { ru: 'Файлы и порядок', en: 'Files and order' },
  'components.materials.orderHint': {
    ru: 'Файлы смонтируем в этом порядке. Поменять местами можно стрелками.',
    en: 'Files will be edited in this order. Use the arrows to reorder them.',
  },
  'components.materials.file': { ru: 'Файл {n}', en: 'File {n}' },
  'components.materials.moveUp': { ru: 'Переместить файл {n} выше', en: 'Move file {n} up' },
  'components.materials.moveDown': { ru: 'Переместить файл {n} ниже', en: 'Move file {n} down' },
  'components.materials.requirements': { ru: 'Требования к видео', en: 'Video requirements' },
  'components.materials.limitSources': {
    ru: 'До {count} записей, вместе до {minutes} минут и {size}.',
    en: 'Up to {count} recordings, {minutes} minutes and {size} in total.',
  },
  'components.materials.limitFile': {
    ru: 'Один файл — до {size}, ориентация любая, горизонтальную приведём к 9:16.',
    en: 'One file up to {size}. Any orientation; landscape is converted to 9:16.',
  },
  'components.materials.limitIllustrations': {
    ru: 'Иллюстрации: до {count} файлов, видео до {minutes} минут и {videoSize}, фото до {photoSize}.',
    en: 'Illustrations: up to {count} files, videos up to {minutes} minutes and {videoSize}, photos up to {photoSize}.',
  },
  'components.materials.illustrationsTitle': { ru: 'Иллюстрации · {count}/{max}', en: 'Illustrations · {count}/{max}' },
  'components.materials.illustrationsHint': {
    ru: 'Видео и фото для врезок, если потребуются',
    en: 'Videos and photos for cutaways, if needed',
  },
  'components.materials.illustrationsMax': { ru: 'Добавлено максимум иллюстраций', en: 'Maximum illustrations added' },
  'components.materials.addIllustrations': { ru: 'Добавить иллюстрации', en: 'Add illustrations' },

  // Кнопка запуска
  'components.launch.starting': { ru: 'Запускаем…', en: 'Starting…' },
  'components.launch.wait': { ru: 'Подождите…', en: 'Please wait…' },
  'components.launch.uploading': { ru: 'Загружаем · {percent}%', en: 'Uploading · {percent}%' },
  'components.launch.retryEdit': { ru: 'Повторить монтаж', en: 'Retry edit' },
  'components.launch.startEdit': { ru: 'Запустить монтаж', en: 'Start editing' },
  'components.launch.retry': { ru: 'Повторить', en: 'Retry' },
  'components.launch.start': { ru: 'Запустить', en: 'Start' },

  // Музыка
  'components.music.playFailed': { ru: 'Не удалось включить музыку. Попробуйте ещё раз.', en: 'Could not play the music. Try again.' },
  'components.music.unavailable': { ru: 'Превью недоступно. Попробуйте другой трек.', en: 'Preview unavailable. Try another track.' },
  'components.music.aria': { ru: 'Превью музыки', en: 'Music preview' },
  'components.music.sample': { ru: '{artist} · пример 15 секунд', en: '{artist} · 15-second sample' },
  'components.music.playbackAria': { ru: 'Воспроизведение музыки', en: 'Music playback' },
  'components.music.stopAria': { ru: 'Остановить превью музыки', en: 'Stop music preview' },
  'components.music.listen': { ru: 'Послушать музыку', en: 'Listen to music' },
  'components.music.loading': { ru: 'Загрузка…', en: 'Loading…' },
  'components.music.pause': { ru: 'Пауза', en: 'Pause' },
  'components.music.another': { ru: 'Другой трек', en: 'Another track' },
  'components.music.auto': { ru: 'Музыку для ролика подберём автоматически.', en: 'We will pick music for your reel automatically.' },
  'components.music.source': { ru: '{license} · источник', en: '{license} · source' },

  // Права на музыку
  'components.musicRights.legacy': {
    ru: 'Для этого старого рендера сведения о музыке не сохранены. Пересоберите ролик, чтобы получить трек с проверенными условиями.',
    en: 'Music details were not saved for this older render. Re-render the reel to get a track with verified terms.',
  },
  'components.musicRights.disabled': { ru: 'Фоновая музыка выключена.', en: 'Background music is off.' },
  'components.musicRights.unavailable': {
    ru: 'Ролик смонтирован без фоновой музыки: подходящего трека с проверенными правами пока нет.',
    en: 'This reel was edited without background music: there is no suitable track with verified rights yet.',
  },
  'components.musicRights.aria': { ru: 'Права на музыку', en: 'Music rights' },
  'components.musicRights.title': { ru: 'Музыка в этом ролике', en: 'Music in this reel' },
  'components.musicRights.attribution': {
    ru: 'Можно публиковать и монетизировать видео при соблюдении условий лицензии. Сохраните подпись ниже в описании публикации.',
    en: 'You can publish and monetize the video if you follow the license terms. Keep the credit below in your post description.',
  },
  'components.musicRights.free': {
    ru: 'Музыка бесплатна для публикации и монетизации. Указывать автора в описании не обязательно.',
    en: 'The music is free to publish and monetize. Crediting the author in the description is optional.',
  },
  'components.musicRights.source': { ru: 'Источник', en: 'Source' },
  'components.musicRights.creditAria': { ru: 'Авторство музыки', en: 'Music credit' },

  // Состояния
  'components.states.retry': { ru: 'Повторить', en: 'Retry' },
  'components.states.offline': {
    ru: 'Нет соединения. Загрузка и генерация продолжатся, как только интернет вернётся.',
    en: 'No connection. Uploads and processing will continue as soon as you are back online.',
  },

  // Кнопка действия
  'components.action.wait': { ru: 'Подождите…', en: 'Please wait…' },

  // Прогресс проекта
  'components.progress.aria': { ru: 'Прогресс монтажа', en: 'Editing progress' },
  'components.progress.done': { ru: 'Ролик готов', en: 'Reel ready' },
  'components.progress.failed': { ru: 'Монтаж прерван', en: 'Editing interrupted' },
  'components.progress.running': { ru: 'Монтаж · в чат через 3-6 мин', en: 'Editing · sent to chat in 3-6 min' },
  'components.progress.barAria': { ru: 'Монтаж', en: 'Editing' },
  'components.progress.details': { ru: 'Подробнее', en: 'Details' },
  'components.progress.view': { ru: 'Смотреть', en: 'View' },

  // Нижняя панель
  'components.tabs.aria': { ru: 'Разделы', en: 'Sections' },
  'components.tabs.new': { ru: 'Монтаж', en: 'Create' },
  'components.tabs.projects': { ru: 'Ролики', en: 'Reels' },
  'components.tabs.balance': { ru: 'Баланс', en: 'Balance' },
  'components.tabs.invite': { ru: 'Пригласить', en: 'Invite' },
  'components.tabs.profile': { ru: 'Профиль', en: 'Profile' },
  'components.tabs.processing': { ru: 'Монтаж в процессе', en: 'Editing in progress' },
  'components.tabs.ready': { ru: 'Готовых роликов: {n}', en: 'Reels ready: {n}' },

  // Полоса в превью
  'components.band.valuetext': { ru: '{percent}% от верха', en: '{percent}% from top' },
});
